<svelte:options runes={false} />

<script>
  export let page;
  export let hasNext;
  export let onPrevious;
  export let onNext;
</script>

{#if page > 1 || hasNext}
  <div class="button-row">
    <button disabled={page === 1} type="button" on:click={onPrevious}>Previous</button>
    <span>Page {page}</span>
    <button disabled={!hasNext} type="button" on:click={onNext}>Next</button>
  </div>
{/if}
